import { render, staticRenderFns } from "./ReferenceView.vue?vue&type=template&id=ccd90d60&scoped=true&"
import script from "./ReferenceView.vue?vue&type=script&lang=js&"
export * from "./ReferenceView.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceView.vue?vue&type=style&index=0&id=ccd90d60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd90d60",
  null
  
)

export default component.exports